import { vars } from '@styles/vanilla-extract/theme.css';

import React from 'react';

import {
	chartCenterCoverClass,
	chartWrapperClass,
	containerClass,
	innerClass,
	legendClass,
	legendColorDotClass,
	legendLabelClass,
	legendsContainerClass,
	titleClass,
} from './style.css';

import ReactApexChart from 'react-apexcharts';

export type RadialBarChartLegendColors = 'primary' | 'black' | 'gray';

export interface RadialBarChartLegend {
	label: string;
	color: RadialBarChartLegendColors;
	value?: string;
	isMain?: boolean;
}

export interface RadialBarChartProps {
	legends?: RadialBarChartLegend[];
	isPositive?: boolean;
	value?: number;
	title?: string;
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const RadialBarChart = ({
	isLoading = false,
	isError = false,
	lackOfPermission = false,
	isPositive,
	title,
	...props
}: RadialBarChartProps) => {
	const value = (isLoading || isError ? 0 : lackOfPermission ? 60 : props.value) ?? 0;
	const legends = props.legends
		? isLoading
			? props.legends.map((legend) => ({
					...legend,
					value: '분석 중',
			  }))
			: isError
			? props.legends.map((legend) => ({
					...legend,
					value: '분석 불가',
			  }))
			: lackOfPermission
			? props.legends.map((legend) => ({ ...legend, label: 'example', value: '00%' }))
			: props.legends
		: undefined;

	console.log(value, 'value');

	return (
		<div className={containerClass({ hasLegends: !!legends })}>
			{legends && (
				<ul className={legendsContainerClass}>
					{legends.map((item, idx) => (
						<li key={idx} className={legendClass({ isMain: item.isMain })}>
							<div className={legendColorDotClass({ color: item.color })} />
							<div className={legendLabelClass}>{item.label}</div>
							<div>{item.value ?? '-'}</div>
						</li>
					))}
				</ul>
			)}

			<div className={innerClass}>
				<div className={chartWrapperClass}>
					<ReactApexChart
						options={{
							chart: {
								type: 'radialBar',
							},
							fill: {
								colors: [
									isPositive
										? vars.global.colors.primary[60]
										: vars.global.colors.gray[80],
								],
							},
							plotOptions: {
								radialBar: {
									hollow: {
										size: '35%',
									},
									dataLabels: {
										show: true,
										name: { show: false },
										value: {
											offsetY: 7,
											formatter(val) {
												return (
													val.toLocaleString('ko-KR', { maximumFractionDigits: 2 }) + '%'
												);
											},
										},
									},
								},
							},
						}}
						series={[value]}
						type="radialBar"
						width={213}
						height={213}
					/>
					{isLoading && <div className={chartCenterCoverClass}>분석 중</div>}
					{isError && <div className={chartCenterCoverClass}>-</div>}
				</div>
				{title && <p className={titleClass}>{title}</p>}
			</div>
		</div>
	);
};

export default RadialBarChart;
